import { getEmployeesVacationRequestsAction } from "../getEmployeesVacationRequests.action";
import $api from "../../../services/axiosService";
// import {mockAccept} from "../../../../components/common/Holidays/HolidaysTable/mockAccept.data";

export const getEmployeesVacationRequestsThunkAction = (date) => async (dispatch) => {
    try {
        dispatch(getEmployeesVacationRequestsAction([]));
        const response = await $api("manager/subordinates/leaves/overlapping", {
            params: {
                from: date.from,
                to: date.to,
            },
        });

        if (response.status === 200) {
            dispatch(getEmployeesVacationRequestsAction(response.data.requests));
        } else {
            dispatch(getEmployeesVacationRequestsAction([]));
        }
    } catch (error) {
    }
};
